import { gql } from '@apollo/client'
import { CORE_LAB_RESULT_FIELDS } from '@src/graphql/fragments/labResult'

const FETCH_LAB_RESULT = gql`
  ${CORE_LAB_RESULT_FIELDS}
  query labResult($id: ID!) {
    labResult(id: $id) {
      ...CoreLabResultFields
    }
  }
`

export default FETCH_LAB_RESULT
